import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';

import { Controllers } from '@shared/core/controllers';

import { Observable } from 'rxjs';
import { ILocationBusinessModel } from '@shared/state';

@Component({
    selector: 'shared-locations-for-intro',
    templateUrl: './locations-for-intro.component.html',
    styleUrls: ['./locations-for-intro.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationsForIntroComponent implements OnInit {
    public locations$: Observable<ILocationBusinessModel[]>;
    public isLoadingLocations$: Observable<boolean>;
    public appMode$: Observable<OLO.Enums.APP_MODE>;

    constructor(
        public controllers: Controllers,
    ) {

    }

    ngOnInit(): void {
        this.appMode$ = this.controllers.appSettings.appLocationMode$();

        this.locations$ = this.controllers.locations.locationsListByAppMode$(3);

        this.isLoadingLocations$ = this.controllers.locations.isLoadingLocations$();
    }

    public handleMoreStores($event: Event): Promise<boolean> {
        return this.controllers.routes.navigateToLocationsSearchView();
    }
}
